import React from "react";
import { DisplayBox, Loading } from "../../components";
import { ApiHelper, PlaylistMessageInterface } from "../../helpers";

interface Props {
  playlistMessage: PlaylistMessageInterface
}

export const SubsetPreview: React.FC<Props> = props => {
  const [messages, setMessages] = React.useState<any[]>(null);
  const [expandIndex, setExpandIndex] = React.useState(-1);
  const init = () => { if (props.playlistMessage?.childPlaylistId) loadInstructions(props.playlistMessage.childPlaylistId); }

  const loadInstructions = async (childPlaylistId: number) => {
    const inst: any = await ApiHelper.getAnonymous("/legacy/playlists/?id=" + childPlaylistId.toString() + "&weight=100&nestedPreview=1");
    const result: string[] = [];
    inst.schedules[0].playlists[0].messages.forEach((m: any) => { result.push(m); });
    setMessages(result);
  }

  React.useEffect(init, [props.playlistMessage?.childPlaylist]);  // eslint-disable-line

  const getBeginningClass = (fromStart: number) => {
    const s = props.playlistMessage.childPlaylistStart;
    const e = props.playlistMessage.childPlaylistEnd;
    let result = "";
    if (s === fromStart) result = "start";
    else if (e === fromStart) result = "end";
    return result;
  }


  const getRows = () => {
    const result: JSX.Element[] = [];
    for (let i = 0; i < messages.length; i++) {
      //let endIdx = messages.length - i;
      const begClass = getBeginningClass(i + 1);

      let chevron = <></>
      const m = messages[i];
      const index = i + 1;
      if (m.templateId === -1 && m.answers.length > 0) {
        if (expandIndex === index) {
          chevron = (<a href="about:blank" onClick={(e) => { e.preventDefault(); setExpandIndex(-1) }} className="float-right">
            <i className="fas fa-chevron-up"></i>
          </a>);
        } else {
          chevron = (<a href="about:blank" onClick={(e) => { e.preventDefault(); setExpandIndex(index) }} className="float-right">
            <i className="fas fa-chevron-down"></i>
          </a>);
        }

      }

      result.push(<tr>
        <td className={begClass}>{i + 1}</td>
        <td>{chevron}{messages[i].name}</td>
      </tr>);

      if (m.templateId === -1 && expandIndex === index) {
        getChildren().forEach(c => result.push(c));
      }

    }
    return result;
  }

  const getChildren = () => {
    const result: JSX.Element[] = [];
    const answers = JSON.parse(messages[expandIndex - 1].answers[0].value);
    for (let i = 0; i < answers.length; i++) {
      const currentIdx = expandIndex + (i + 1) / 1000;
      const begClass = getBeginningClass(currentIdx);

      result.push(<tr className="subsetChild">
        <td className={begClass}>{currentIdx}</td>
        <td>{answers[i].name}</td>
      </tr>);
    }

    return result;
  }


  const getContents = () => {
    if (!messages) return <Loading />
    else return (<table className="table table-sm" id="subsetPreview" >
      <tr>
        <th>Index</th>
        <th>Message</th>
      </tr>
      {getRows()}
    </table>)
  }

  return (
    <DisplayBox headerIcon="fas fa-equals" headerText="Current playlist items" >
      {getContents()}
    </DisplayBox>
  );
};